/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import classnames from 'classnames';
import { withTranslation } from 'next-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Flash from './UI/organisms/Flash';
import Header from './UI/organisms/Header';
import Footer from './UI/organisms/Footer';
import FooterWithContents from './UI/organisms/FooterWithContents';
import Modal from './UI/organisms/Modal';
import * as AuthActions from '../actions/auth';
import * as CurrentUserActions from '../actions/currentUser';
import * as ModalActions from '../actions/modal';
import * as FlashActions from '../actions/flash';
import * as GeoDataActions from '../actions/geoData';
import SecondaryModal from './UI/organisms/SecondaryModal';
import AppLoadingMessage from './UI/organisms/AppLoadingMessage';
import appUtils from '../utils/appUtils';
// import SetupGa  from '../../ga';
import SEO from './SEO';
import { useCookies } from 'react-cookie';
import { useRouter } from 'next/router';

function mapStateToProps(state) {
  const { auth, modal, flash, appLoading, geoData } = state;
  const { user, loaded, authToken } = auth;
  return {
    user,
    authLoaded: loaded,
    authToken,
    modal,
    flash,
    geoData: geoData.geoData,
    isAppLoading: appLoading.isLoading,
    appLoadingMessage: appLoading.message,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators<any, any>(AuthActions, dispatch),
    userActions: bindActionCreators<any, any>(CurrentUserActions, dispatch),
    modalActions: bindActionCreators<any, any>(ModalActions, dispatch),
    flashActions: bindActionCreators<any, any>(FlashActions, dispatch),
    geoDataActions: bindActionCreators<any, any>(GeoDataActions, dispatch),
  };
}

const Layout = (props) => {
  const {
    i18n,
    children,
    user,
    flash,
    isAppLoading,
    appLoadingMessage,
    geoDataActions,
    flashActions,
  } = props;
  const router = useRouter();
  const [cookies] = useCookies(['NEXT_LOCALE']);
  const language = i18n.language;
  const currentLocale = appUtils.getLocaleFromLang(language);
  const nextLocale = (cookies as any).NEXT_LOCALE;

  // biome-ignore lint/correctness/useExhaustiveDependencies: i18n is a singleton and should not trigger re-renders
  useEffect(() => {
    if (nextLocale && i18n.language !== nextLocale) {
      i18n?.changeLanguage(nextLocale);
    }

    if (nextLocale && router.locale !== nextLocale) {
      router.replace(router.pathname, router.asPath, {
        locale: nextLocale,
        scroll: false,
      });
    }
  }, [i18n, nextLocale, router.asPath, router.locale, router.pathname]);

  useEffect(() => {
    geoDataActions.get();
  }, [geoDataActions]);

  const headerProps = {
    user,
    currentLocale,
  };

  const renderFooter = () => {
    if (currentLocale === 'ja') {
      return <FooterWithContents currentLocale={currentLocale} />;
    } else {
      return <Footer currentLocale={currentLocale} />;
    }
  };

  const renderFlash = () => {
    const { message, type, sticky, autoDisappear } = flash;
    const flashProps = {
      message,
      type,
      sticky,
      autoDisappear,
      clearFlashMessage: flashActions.clearMessage,
    };
    return <Flash {...flashProps} />;
  };

  const appWrapperClass = classnames({ loading: isAppLoading });
  return (
    <div id="app">
      <div id="app-wrapper" className={appWrapperClass}>
        <SEO />
        <AppLoadingMessage message={appLoadingMessage} />
        <Modal />
        <SecondaryModal />
        {renderFlash()}
        <Header {...headerProps} />
        {children}
        {renderFooter()}
      </div>
    </div>
  );
};

const wrapped = withTranslation('common')(Layout);

export default connect(mapStateToProps, mapDispatchToProps)(wrapped);
